export default class MissingUrlRidError extends Error {
    constructor() {
        super();
        this.name = 'MissingUrlRidError';
        this.message = `URL is missing the "rid" parameter. Referring page: ${document.referrer || 'no referrer'}.`;
    }
}
